import { useEffect, useState } from "react"
import _ from "lodash"
import { SketchPicker, ChromePicker } from "react-color"
import { FormLabel } from "carbon-components-react"
import "./ColorPicker.scss"

const ColorPicker = (props) => {

    const [value, setValue] = useState({
        hex: "#ffffff"
    })
    const [buttonValue, setButtonValue] = useState()
    const [popoverOpen, setPopoverOpen] = useState(false)

    useEffect(() => {
        setValue(props.initialValue)
        setButtonValue(props.initialValue)
    }, [props.initialValue])

    let Element = ChromePicker

    const onChange = (e) => {
        console.log("color", e)
        const hex = (_.isEmpty(e) || !e) ? "" : e.hex
        setButtonValue(hex)
        props.onChange(hex)
    }

    const handleClick = () => {
        setPopoverOpen(true)
    }
    const handleClose = () => {
        setPopoverOpen(false)
    };
    const popover = {
        position: 'absolute',
        zIndex: '9100',
    }
    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    }

    return (
        <div className="color-picker">
            {
                props.labelText ? (
                    <div>
                        <FormLabel>
                            {props.labelText}
                        </FormLabel>
                    </div>
                ) : null
            }
            <div onClick={handleClick} className="color-picker__btn">
                <div className="color-picker__btn--value">
                    <div className="color-picker__btn--value-content">
                        {buttonValue || "Select"}
                    </div>
                </div>
                <div className="color-picker__btn--color" style={{
                    backgroundColor: buttonValue
                }} />
                {/* {
                    props.fallbackValue ? (
                        <div className="color-picker__btn--color" style={{
                            backgroundColor: props.fallbackValue
                        }} />
                    ) : null
                } */}
                {
                    buttonValue ? (
                        <div
                            className="color-picker__btn--clear"
                            onClick={() => onChange("")}>
                            <div className="color-picker__btn--value-content">
                                X
                            </div>
                        </div>
                    ) : null
                }
            </div>
            {
                popoverOpen ? (
                    <div style={popover}>
                        <div style={cover} onClick={handleClose} />
                        <Element
                            disableAlpha={true}
                            color={value || {
                                hex: "#ffffff"
                            }}
                            onChange={(e) => onChange(e)}
                        />
                    </div>
                ) : null
            }
        </div>

    )
}

export default ColorPicker